import { z } from "zod/v4"
import { CreatedAt, UpdatedAt } from "./system"
import { ItemId, ItemIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { DocumentStatus, InitialLookStatus, MediaImage } from "../common"

export type CreateInitialLookRequest = z.infer<typeof CreateInitialLookRequest>
export const CreateInitialLookRequest = z.object({
  itemId: ItemIdSchema,
  priority: z.coerce.number().int(),
  status: DocumentStatus,
})

export type UpdateInitialLookRequest = z.infer<typeof UpdateInitialLookRequest>
export const UpdateInitialLookRequest = z.object({
  priority: z.coerce.number().int().optional(),
  status: InitialLookStatus.optional(),
  updateSelectionImage: z.boolean().optional(),
})

export const InitialLookDocumentMeta = z.object({
  item_id: ItemIdSchema.describe("アイテムID（ドキュメントIDと同じ）"),
  priority: z.number().int().describe("表示優先度。数値が大きいほど先に表示する。"),
  status: InitialLookStatus.describe("公開状態。public=有効、hidden=無効、deleted=削除済み"),
  media: MediaImage.describe("選択画像の CDN URL 付き MediaImage。value には CDN URL、location には gs:// URL が格納される。"),
})

export type InitialLookDocumentMeta = z.infer<typeof InitialLookDocumentMeta>

export const InitialLookDocumentBody = z.intersection(
  InitialLookDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type InitialLookDocumentBody = z.infer<typeof InitialLookDocumentBody>

export const InitialLookDocument = InitialLookDocumentBody

export type InitialLookDocument = z.infer<typeof InitialLookDocument>

export class InitialLookDocuments {

  static toDocumentData(doc: InitialLookDocument): object {
    return {
      ...doc,
      item_id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): InitialLookDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      item_id: ItemId(doc.id),
      priority: data["priority"],
      status: data["status"],
      media: data["media"] as MediaImage,
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
